/**
 * 安全周报常量配置
 */

// 四象限标签配置
// 根据 API 文档调整象限编号：
// Q1: 扩散中（右下）, Q2: 已发酵（右上）, Q3: 情绪放大（左上）, Q4: 稳定（左下）
export const QUADRANT_LABELS = {
  1: { key: 'spreading', color: '#D4B106' }, // 扩散中，关注
  2: { key: 'fermented', color: '#F5222D' }, // 已发酵，必须介入
  3: { key: 'emotional', color: '#FAAD14' }, // 情绪放大，重点关注
  4: { key: 'stable', color: '#838697' }, // 稳定/噪音，观察即可
} as const;

// 四象限完整配置（国际化 key + 样式）
// label: 完整标签（图表象限标签、下载导出）
// name: 简称（汇总展示、表格列）
export const QUADRANT_CONFIG: Record<
  number,
  {
    label: string;
    name: string;
    bgColor: string;
    textColor: string;
    labelColor: string;
  }
> = {
  1: {
    label: 'Spreading – Attention Required',
    name: 'Spreading',
    bgColor: 'rgba(212, 177, 6, 0.16)',
    textColor: '#262832',
    labelColor: '#D4B106',
  },
  2: {
    label: 'Escalated – Immediate Action Required',
    name: 'Escalated',
    bgColor: 'rgba(245, 34, 45, 0.16)',
    textColor: '#F5222D',
    labelColor: '#F5222D',
  },
  3: {
    label: 'Emotion Amplifying – High Attention Required',
    name: 'Emotion Amplification',
    bgColor: 'rgba(250, 173, 20, 0.16)',
    textColor: '#262832',
    labelColor: '#FAAD14',
  },
  4: {
    label: 'Stable – Monitor Only',
    name: 'Stable',
    bgColor: 'rgba(0, 0, 0, 0.05)',
    textColor: '#262832',
    labelColor: '#838697',
  },
};

// 举报类型配置（颜色 + 中英文）
// key 与后端 report_type 字段对应
// @deprecated 请使用 CATEGORY_CONFIG
export const REPORT_TYPE_CONFIG: Record<
  string,
  { color: string; text: string }
> = {
  cheat: { color: '#F5222D', text: 'Cheat' },
  language: { color: '#FAAD14', text: 'Language Violation' },
  behavior: { color: '#1890FF', text: 'Negative Behavior' },
};

// 一级话题（category）配置
// key 与后端 category 字段对应
export const CATEGORY_CONFIG: Record<string, { color: string }> = {
  Hack: { color: '#FF3B30' },
  'Banned Speech': { color: '#FF9500' },
  'Negative Behavior': { color: '#FFCC00' },
};

// 气泡大小范围（px）
export const BUBBLE_SIZE = {
  min: 14,
  max: 40,
} as const;

// 图表切换类型
export const CHART_TYPES = {
  line: 'line',
  pie: 'pie',
  stackedBar: 'stacked-bar',
  table: 'table',
  wordCloud: 'word-cloud',
} as const;

// 维度类型
export const DIMENSION_TYPES = {
  reportType: 'category',
  subTopic: 'subcategory',
  language: 'language',
  channel: 'channel',
  date: 'date',
} as const;

// 维度选项配置（用于复选框、表格列等UI组件）
export const DIMENSION_OPTIONS = [
  {
    value: DIMENSION_TYPES.date,
    checkboxLabel: 'By Date',
    columnLabel: 'Date',
    columnKey: 'date',
    width: 150,
  },
  {
    value: DIMENSION_TYPES.subTopic,
    checkboxLabel: 'By Subtopic',
    columnLabel: 'Subtopic',
    columnKey: 'subcategory',
    width: 150,
  },
  {
    value: DIMENSION_TYPES.language,
    checkboxLabel: 'By Language',
    columnLabel: 'Language',
    columnKey: 'language',
    width: 150,
  },
  {
    value: DIMENSION_TYPES.channel,
    checkboxLabel: 'By Channel',
    columnLabel: 'Channel',
    columnKey: 'channel',
    width: 150,
  },
] as const;

// 日期粒度
export const DATE_GRANULARITY = {
  day: 'day',
  week: 'week',
} as const;
